<template>
  <div v-if="visible" class="modal-overlay" @click.self="closeModal">
    <div class="modal-content">
      <h3>{{ t('pdfModalTitle', lang) }}</h3>

      <div class="form-group">
        <label>{{ t('pdfOrientation', lang) }}</label>
        <select v-model="options.orientation" class="form-input">
          <option value="portrait">{{ t('pdfPortrait', lang) }}</option>
          <option value="landscape">{{ t('pdfLandscape', lang) }}</option>
        </select>
      </div>

      <div class="form-group">
        <label>{{ t('pdfQuality', lang) }}</label>
        <select v-model="options.quality" class="form-input">
          <option value="low">{{ t('pdfQualityLow', lang) }}</option>
          <option value="medium">{{ t('pdfQualityMedium', lang) }}</option>
          <option value="high">{{ t('pdfQualityHigh', lang) }}</option>
        </select>
      </div>

      <div class="form-check">
        <input type="checkbox" id="includeKpi" v-model="options.includeKpi" />
        <label for="includeKpi">{{ t('pdfIncludeKpi', lang) }}</label>
      </div>

      <div class="form-check">
        <input type="checkbox" id="hideButtons" v-model="options.hideButtons" />
        <label for="hideButtons">{{ t('pdfHideButtons', lang) }}</label>
      </div>

      <div class="form-check">
        <input type="checkbox" id="fitToPage" v-model="options.fitToPage" />
        <label for="fitToPage">{{ t('pdfFitToPage', lang) }}</label>
      </div>

      <div class="modal-actions">
        <button class="btn-secondary" @click="closeModal">{{ t('cancel', lang) }}</button>
        <button class="btn-primary" @click="exportPDF">{{ t('export', lang) }}</button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { t } from '../i18n/index.js';

const props = defineProps({
  visible: { type: Boolean, default: false },
  lang: { type: String, default: 'ca_es' }
});

const emit = defineEmits(['export', 'close']);

const options = ref({
  orientation: 'landscape',
  quality: 'high',
  includeKpi: true,
  hideButtons: true,
  fitToPage: true
});

function closeModal() {
  emit('close');
}

function exportPDF() {
  emit('export', options.value);
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  border-radius: 12px;
  padding: 24px;
  max-width: 400px;
  width: 90%;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
}

.modal-content h3 {
  margin: 0 0 20px 0;
  color: #111827;
  font-size: 1.2rem;
}

.form-group {
  margin-bottom: 16px;
}

.form-group label {
  display: block;
  margin-bottom: 6px;
  font-size: 0.875rem;
  font-weight: 600;
  color: #6b7280;
  text-transform: uppercase;
}

.form-input {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  font-size: 0.875rem;
  font-family: inherit;
}

.form-input:focus {
  outline: none;
  border-color: #0b5394;
  box-shadow: 0 0 0 3px rgba(11, 83, 148, 0.1);
}

.form-check {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
  font-size: 0.875rem;
  color: #374151;
}

.form-check input[type="checkbox"] {
  width: 16px;
  height: 16px;
  cursor: pointer;
  accent-color: #0b5394;
}

.modal-actions {
  display: flex;
  gap: 12px;
  margin-top: 24px;
  justify-content: flex-end;
}

.btn-primary,
.btn-secondary {
  padding: 8px 20px;
  border-radius: 8px;
  border: none;
  font-weight: 600;
  font-size: 0.875rem;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-primary {
  background: #0b5394;
  color: white;
}

.btn-primary:hover {
  background: #0a4277;
}

.btn-secondary {
  background: white;
  color: #374151;
  border: 1px solid #d1d5db;
}

.btn-secondary:hover {
  background: #f9fafb;
}
</style>
